import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { CheckMandateResponseBody } from '../../../../authorizations/src/domain/Authorization/entities/CheckMandateResponseDTO';
import { TransactionWithDealerRate } from '../../../../transaction/src/domain/Transaction/entities/TransactionWithDealerRate';
import { ConsolidatedTransactionDetails } from '../../../../transaction/src/domain/Transaction/entities/ConsolidatedTransaction';

export interface TransactionsProviderProps {
  transactionsList: Nullable<TransactionWithDealerRate[]>;
}

export type TransactionsProviderState = {
  checkAuthorizationData?: Nullable<CheckMandateResponseBody>;
  transactionsList?: Nullable<TransactionWithDealerRate[]>;
  transactionDetails: Nullable<ConsolidatedTransactionDetails>;
  selectedTransaction: Nullable<TransactionWithDealerRate>;
  onCheckAuthorizationMutation: () => void;
  actions: {
    onSelectTransaction: (orderId: Nullable<number>) => void;
    onRefetchTransactionDetails: () => void;
  };
  loadingState: {
    isLoadingTransactionDetails: boolean;
    isLoadingCheckAuthorization: boolean;
  };
  errorState: {
    transactionDetailsError?: AxiosError<APIGatewayResponse<ConsolidatedTransactionDetails>, any>;
    checkAuthorizationError?: AxiosError<APIGatewayResponse<CheckMandateResponseBody>, any>;
  };
};

export enum TransactionsActionTypes {
  setSelectedTransaction = '@@/Transactions/setSelectedTransaction',
}
